export enum ItemsMosaicTheme {
  Row = 'row',
  Mosaic = 'mosaic'
}
